<template>
  <div>
    <Tabs :tabIndex="tabIndex"/>
    <b-container>
      <information/>
    </b-container>
  </div>
</template>

<script>
import Tabs from '@/components/Admin/Company/Tabs'
import Information from '../../../components/Admin/Company/Information'
export default {
  name: 'DetailVendor_view',
  components: {
    Tabs,
    Information
  },
  data () {
    return {
      tabIndex: 1
    }
  }
}
</script>
<style scoped lang="scss">
  @import '@/assets/stylesheet/vendor/detail_vendor.scss';
</style>



// WEBPACK FOOTER //
// src/views/Admin/Company/Detail.vue